import {
  faHandHoldingHeart,
  faMessage,
  faVideo,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FlexBox,
  JoonColorExpanded,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

export const PaywallBundlingCoachingPlan = () => {
  const { t } = useTranslation()
  const coachingPlanItems = [
    {
      icon: (
        <FontAwesomeIcon
          icon={faHandHoldingHeart}
          size="lg"
          color={JoonUIColor.text.primaryAccent}
        />
      ),
      title: t("PAYWALL_COACHING_ITEM1_TITLE"),
      subtitle: t("PAYWALL_COACHING_ITEM1_SUBTITLE"),
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={faMessage}
          size="lg"
          color={JoonUIColor.text.primaryAccent}
        />
      ),
      title: t("PAYWALL_COACHING_ITEM2_TITLE"),
      subtitle: t("PAYWALL_COACHING_ITEM2_SUBTITLE"),
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={faVideo}
          size="lg"
          color={JoonUIColor.text.primaryAccent}
        />
      ),
      title: t("PAYWALL_COACHING_ITEM3_TITLE"),
      subtitle: t("PAYWALL_COACHING_ITEM3_SUBTITLE"),
    },
  ]

  return (
    <FlexBox
      direction="column"
      gap={SPACING.space2}
      style={{
        borderTop: `1px solid ${JoonUIColor.border.default}`,
        paddingTop: SPACING.space3,
      }}
    >
      <Typography variant="bodyBold" textAlign="left">
        {t("PAYWALL_COACHING_HOW_IT_WORKS")}
      </Typography>
      <FlexBox direction="column" gap={SPACING.space4}>
        {coachingPlanItems.map(({ icon, title, subtitle }, index) => (
          <FlexBox
            key={index}
            direction="row"
            align="center"
            justify="flex-start"
            gap={SPACING.space2}
            wrap={false}
          >
            <FlexBox
              align="center"
              justify="center"
              style={{ width: 20, height: 20 }}
            >
              {icon}
            </FlexBox>
            <FlexBox direction="column" align="flex-start" justify="center">
              <Typography
                variant="bodySmallBold"
                textAlign="left"
                color={JoonUIColor.text.primaryAccent}
                style={{ lineHeight: "1.2" }}
              >
                {title}
              </Typography>
              <Typography variant="bodyXSmallBold" textAlign="left">
                {subtitle}
              </Typography>
            </FlexBox>
          </FlexBox>
        ))}
      </FlexBox>
      <FlexBox
        direction="column"
        align="center"
        gap={SPACING.space4}
        style={{
          marginTop: SPACING.space4,
          paddingTop: SPACING.space2,
          paddingBottom: SPACING.space4,
          backgroundColor: JoonColorExpanded.yellow100,
          borderRadius: SPACING.space2,
          overflow: "visible",
        }}
      >
        <Typography variant="bodyBold" textAlign="center">
          {t("PAYWALL_COACHING_WHY_TITLE")}
        </Typography>
        <Typography
          variant="bodySmall"
          textAlign="center"
          style={{ paddingLeft: SPACING.space2, paddingRight: SPACING.space2 }}
        >
          {t("PAYWALL_COACHING_WHY_DESC")}
        </Typography>
        <img
          src="/images/coaches_and_joe.png"
          alt="Joon Coaching"
          style={{
            width: "100%",
            userSelect: "none",
            pointerEvents: "none",
          }}
        />
      </FlexBox>
    </FlexBox>
  )
}
